export const ConsumerSubmitFormUat = {
  viewButton: 'workflow.consumerSubmit.viewButton',
  submitButton: 'workflow.consumerSubmit.submitButton',
  authorizedElectronicCommunicationConsentCheckbox:
    'workflow.consumerSubmit.authorizedElectronicCommunicationConsentConsentCheckbox',
  creditConsent: 'workflow.consumerSubmit.creditConsent',
}
